import React, { Component } from 'react';
import MouseClickSensor from "../../utils/MouseClickSensor";
import DiagramsContainer from '../../containers/DiagramsContainer';
import DiagramUtils from "../../utils/DiagramUtils";
import Model from "./PaperModel";
import ModelBase from "../Model";

import moment_lib from 'moment';
import { message as antd_message, Modal as antd_Modal } from 'antd';
import { FetchHelper as fh } from "@yulintu/freesia-core";
import { getRandomColor } from "../../utils/predefine-color";
import { parseResultToJson as parseResultToJsonHelper } from '../../utils/helper';
import _loadjs from '../../utils/loadjs';

export default class Paper extends Component {

    state = {
    };

    id = `paper-${Math.random()}`;
    style = ""
    mouseClickSensor = new MouseClickSensor(e => this.onClick(e));
    listeners = [];

    constructor(props, context) {
        super(props, context);
    }

    setDom(ref) {
        if (this.dom)
            return;

        this.dom = ref;
        this.dom.setAttribute("style", this.style);
        this.props.model._sys.designer = this.designer;
        this.props.model._sys.dom = this.dom;
        this.props.model._sys.ui = this;
    }

    componentWillMount() {

        this.designer = this.props.designer;
        this.unregisterResolutionChangedListener = this.designer.registerResolutionChangedListener(c => {
            this.updateLayout();
        });
        this.unregisterExtentChangedListener = this.designer.registerExtentChangedListener(c => {
            this.updateLayout();
        });
        this.unregisterPropertyChangedListener = this.props.model.registerPropertyChangedListener((name, valOld, valNew) => {

            if ((name === "layoutOrientation" ||
                name === "flexWrap" ||
                name === "alignItems"
            ) && this.containerRef)
                this.containerRef.forceUpdate();

            if (name === "isExpanded") {
                return;
            }

            this.updateLayout();
            this.designer.refresh();
            this.designer.properties.needSave = true;
            // this.setState({});
        })
    }

    componentWillUnmount() {
        this.unregisterResolutionChangedListener();
        this.unregisterExtentChangedListener();
        this.unregisterPropertyChangedListener();
    }

    runActions(actions, data) {
        return this.props.model.runActions(actions, data);
    }

    runScript(script, customDataContext, customModel, args, opts) {
        return this.props.model.runScript(script, customDataContext, customModel, args, opts);
    }

    listenDataChanged(name, listener) {
        let un = this.designer.registerDataChangedListener(name, obj => {
            listener && listener(obj);
        });

        this.listeners.push(un);
    }

    createModel(type) {
        return DiagramUtils.createModel(type);
    }

    createModelByTemplate(id) {
        return DiagramUtils.createModelByTemplate(this.props.model._sys.designer, id);
    }

    updateLayout() {

        const extent = this.designer.extent;
        const resolution = this.designer.resolution;
        let { x, y } = this.props.model;
        let model = this.props.model;

        let sx = (x - extent.left) / resolution;
        let sy = (y - extent.top) / resolution;

        let scale = 1 / resolution;

        this.style = model.viewFitToWindow && this.designer.mode === "view" ?
            `left: 0px; top: 0px; width: 100%; height: 100%; transform: scale(${scale}); display:${model.visible ? 'block' : 'none'}` :
            `left: ${sx}px; top: ${sy}px; width: ${Model.lengthCssValue(model.width)}; height: ${Model.lengthCssValue(model.height)}; transform: scale(${scale}); display:${model.visible ? 'block' : 'none'}`;

        if (!this.dom)
            return;

        this.dom.setAttribute("style", this.style);
    }

    // onClick(e) {
    //     this.designer.selectedItems = this.props.model;
    // }

    // onMouseDown(e) {
    //     if (e.button === 0 && e.target.id === this.id)
    //         this.mouseClickSensor.down(e);
    // }

    // onMouseUp(e) {
    //     if (e.button === 0 && e.target.id === this.id)
    //         this.mouseClickSensor.up(e);
    // }

    render() {

        return (
            <div id={this.id} ref={ref => this.setDom(ref)} className={"paper " + (this.props.className || "")}>
                <div className={"paper-ui"} style={this.props.model.toStyle()}>
                    <DiagramsContainer ref={ref => this.containerRef = ref}
                        diagrams={this.props.diagrams}
                        designer={this.props.designer}
                        parent={this.props.model}
                        flag={this.props.model.flag} />
                </div>
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "页面",
    svg: "#anticon-component",
    enabled: false,
});